import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.domain.related;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'DOMAIN_RELATED',
	method: 'POST',
	url: '/domain/related.json',
});

export { actions, reducer, sagas, selectors };
